import debug from 'debug';
import SearchUrl from './search-url';

const log = debug('SearchBox:Utils:Data');

class Data {
	/**
	 * Builds the array and objects nessesary for the Awesomeplete to function
	 * @param {*} data 
	 * @returns {JSON}
	 */
	static parse(data) {
		const parsedAdverts = data.adverts.map(item => {
			return {
				label: item,
				value: {
					url: SearchUrl.get(item)
				}
			}
		});

		const parsedCustomers = data.customers.map(customer => {
			return {
				label: customer.name,
				value: {
					url: customer.customerUrl,
					imageUrl: customer.circleLogoUrl
				}
			}
		});

		return [].concat(parsedCustomers, parsedAdverts);
	}
}

export default Data;
